import { isDeepEqual } from '@attain-apps/data-utils'
import * as store from '@attain-apps/fe/web/main/lib/store'
import { TypeChecker } from '@attain-apps/type-guards'
import * as rxjs from 'rxjs'

import type { Plugin } from '../plugin'

const DEBOUNCE_TIME_MS = 300

/**
 * Watches duplicate search fields in the current employee edit, then requests a
 * debounced duplicate lookup for the latest edit and context.
 */
export const loadForCurrentEntityOnEditedEntityChange = store.effects.create(
  (feature: Plugin['feature'], plugin: Plugin) =>
    plugin.collection.plugins.currentEntityPlugin.feature.selectors
      .getEditedEntity()
      .asObservable.pipe(
        rxjs.filter(TypeChecker.isNotNullish.raw),
        rxjs.map(({ name, jobTitleId, organization }) => ({
          jobTitleId,
          name,
          organization,
        })),
        rxjs.distinctUntilChanged(isDeepEqual),
        rxjs.debounceTime(DEBOUNCE_TIME_MS),
        rxjs.map(() =>
          feature.actions.loadForCurrentEntity.request
            .from(
              '(effect) load duplicate employees for current entity on edited entity change',
            )
            .create(),
        ),
      ),
)
